/* eslint-disable */
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import PropTypes from 'prop-types';
import "../../styles/ComponentsStyles/Organizational/Management/Staffs/PieChart.style.css"; // Create or update style as needed

const PieChartComponent = ({ 
    data, 
    valueKey = 'value', 
    totalKey = 'total', 
    nameKey = 'name', 
    colorKey = 'color', 
    width = 450, 
    height = 450 
}) => {

    const CustomTooltip = ({ active, payload, coordinate }) => {
        if (active && payload && payload.length) {
            const entry = payload[0].payload;
            const percentage = ((entry[valueKey] / entry[totalKey]) * 100).toFixed(2);
            const tooltipX = coordinate ? coordinate.x - 50 : 0;
            const tooltipY = coordinate ? coordinate.y - 80 : 0;

            return (
                <div
                    className="customToolTip"
                    style={{
                        position: 'absolute',
                        top: `${tooltipY}px`,
                        left: `${tooltipX}px`,
                        backgroundColor: 'white',
                        padding: '5px 10px',
                        borderRadius: '8px',
                        boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                        fontFamily: "Poppins-Regular",
                        fontSize: "12px",
                        textAlign: "center",
                    }}
                >
                    <p>{percentage}%</p>
                    <p>{entry[nameKey]}</p>
                </div>
            );
        }
        return null;
    };

    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, index }) => {
        const RADIAN = Math.PI / 180;
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        const entry = data[index];
        const labelText = `${entry[nameKey]?.charAt(0)}-${entry[valueKey]}/${entry[totalKey]}`;

        return (
            <text
                x={x}
                y={y}
                fill="white"
                textAnchor="middle"
                dominantBaseline="central"
                style={{
                    fontFamily: "Poppins-Regular",
                    fontSize: "10px",
                }}
            >
                {labelText}
            </text>
        );
    };

    return (
        <div className="pieChart">
            <PieChart width={width} height={height}>
                <Pie
                    data={data}
                    cx="50%"
                    cy="50%"
                    outerRadius={120}
                    dataKey={(entry) => (entry[valueKey] / entry[totalKey]) * 100}
                    label={renderCustomizedLabel}
                    labelLine={false}
                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry[colorKey]} />
                    ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} cursor={false} />
            </PieChart>
        </div>
    );
};

PieChartComponent.propTypes = {
    data: PropTypes.array.isRequired,
    valueKey: PropTypes.string,
    totalKey: PropTypes.string,
    nameKey: PropTypes.string,
    colorKey: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
};

export default PieChartComponent;
